export default {
  en: {
    affiliates: {
      title: 'Affiliate Program',
      earn: 'Earn 20% Comission for Every Referral',
      join: 'Join our affiliate program and earn by promoting the best platform for aviation radio training. Help pilots succeed in their exams while making money at the same time!',
      yourlink: 'Your affiliate link',
      yourReferrals: 'Your referrals',
      warning: 'Please note that the affiliate link contains your username. If you change your username, the link will not work as intended.',
      copied: 'Affiliate link copied to clipboard',
      copyError: 'Failed to copy affiliate link',
      noReferrals: 'Your referrals will show here.',
    }
  },
  de: {
    affiliates: {
      title: 'Affiliate Programm',
      earn: 'Verdiene 20% Provision für jede Empfehlung',
      join: 'Tritt unserem Affiliate-Programm bei und verdiene Geld, indem du die beste Plattform für die Ausbildung in der Luftfahrt bewirbst. Hilf Piloten, ihre Prüfungen zu bestehen und gleichzeitig Geld zu verdienen!',
      yourlink: 'Dein Affiliate-Link',
      yourReferrals: 'Deine Empfehlungen',
      yourReferralsCount: 'Deine Empfehlungen:',
      warning: 'Bitte beachte, dass der Affiliate-Link deinen Benutzernamen enthält. Wenn du deinen Benutzernamen änderst, funktioniert der Link nicht wie beabsichtigt.',
      copied: 'Affiliate-Link in die Zwischenablage kopiert',
      copyError: 'Fehler beim Kopieren des Affiliate-Links',
      noReferrals: 'Deine Empfehlungen werden hier angezeigt.',
    }
  },
  at: {},
  es: {
    affiliates: {
      title: 'Programa de afiliados',
      earn: 'Gana un 20% de comisión por cada referido',
      join: 'Únete a nuestro programa de afiliados y gana dinero promocionando la mejor plataforma para el entrenamiento de radio de aviación. ¡Ayuda a los pilotos a tener éxito en sus exámenes mientras ganas dinero al mismo tiempo!',
      yourlink: 'Tu enlace de afiliado',
      yourReferrals: 'Tus referidos',
      yourReferralsCount: 'Tus referidos:',
      warning: 'Ten en cuenta que el enlace de afiliado contiene tu nombre de usuario. Si cambias tu nombre de usuario, el enlace no funcionará como se esperaba.',
      copied: 'Enlace de afiliado copiado al portapapeles',
      copyError: 'Error al copiar el enlace de afiliado',
      noReferrals: 'Tus referidos aparecerán aquí.',
    }
  },
  uk: {
    affiliates: {
      title: 'Партнерська програма',
      earn: 'Заробляйте 20% комісії за кожного реферала',
      join: 'Приєднуйтесь до нашої партнерської програми та заробляйте, просуваючи найкращу платформу для підготовки до авіаційних радіоекзаменів. Допоможіть пілотам успішно скласти іспити, заробляючи гроші одночасно!',
      yourlink: 'Ваше партнерське посилання',
      yourReferrals: 'Ваші реферали',
      yourReferralsCount: 'Ваші реферали:',
      warning: 'Зверніть увагу, що партнерське посилання містить ваше ім\'я користувача. Якщо ви зміните своє ім\'я користувача, посилання не працюватиме належним чином.',
      copied: 'Партнерське посилання скопійовано в буфер обміну',
      copyError: 'Не вдалося скопіювати партнерське посилання',
      noReferrals: 'Ваші реферали з\'являться тут.',
    }
  }
}
